"use client"
import { useHeader } from "@/hooks/headerContext";
import { useEffect } from "react";

export default function HeaderDataCount({ count }: { count: any }) {
  const { setDataCount } = useHeader();

  useEffect(() => {
    setDataCount(count);
  }, [count]);

  return <></>;
}
